import { Controller } from "@hotwired/stimulus";

// Fades an image in over its skeleton once the browser has it. The skeleton
// keeps painting until the fade ends so the slot never flashes the page
// background. A cached image can finish before Stimulus connects, so
// `connect` handles that case without animating.
export default class extends Controller {
  static targets = ["image"];

  connect() {
    if (this.imageTarget.complete) this.show();
  }

  reveal() {
    this.imageTarget.classList.remove("opacity-0");
  }

  settle() {
    this.element.classList.remove("skeleton");
  }

  show() {
    this.reveal();
    this.settle();
  }
}
